<template>
    <div class="section how-it-works fade-in-section">
        <h2 class="section-title">How It Works</h2>
        <div class="steps-container">
            <div 
                v-for="(step, index) in steps" 
                :key="index"
                class="step"
            >
                <div class="step-number">{{ step.number }}</div>
                <h3>{{ step.title }}</h3>
                <p class="description">{{ step.description }}</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'HowItWorksSection',
    data() {
        return {
            steps: [
                {
                    number: 1,
                    title: 'Select Your Topics',
                    description: `Pick which module and syllabus dot point you want to drill.
No filler content.`
                },
                {
                    number: 2,
                    title: 'Practice Questions',
                    description: `Answer questions tailored to your picks.
Get feedback the second you submit.`
                },
                {
                    number: 3,
                    title: 'Learn & Improve',
                    description: `Practice every day and improve from your mistakes.
Watch as your weaknesses shrink.`
                }
            ]
        };
    }
};
</script>

<style scoped>
.section {
    position: relative;
    z-index: 2;
    padding: 80px 20px;
    max-width: 80vw;
    margin: 0 auto;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    border-bottom: 1px solid var(--accent);
}

.section-title {
    font-size: 48px;
    text-align: center;
    margin-bottom: 60px;
    color: var(--text-primary);
}

.how-it-works {
    background: transparent;
}

.steps-container {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 40px;
}

.step {
    text-align: center;
}

.step-number {
    width: 60px;
    height: 60px;
    background: var(--accent);
    color: var(--bg-primary);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 28px;
    font-weight: 700;
    margin: 0 auto 20px;
}

.step h3 {
    font-size: 24px;
    color: var(--text-secondary);
    margin-bottom: 15px;
}

.step p {
    font-size: 16px;
    color: var(--text-primary);
    opacity: 0.8;
    line-height: 1.6;
}

.fade-in-section {
    opacity: 0;
    transform: translateY(30px);
    transition: opacity 0.8s ease-out, transform 0.8s ease-out;
}

.fade-in-section.is-visible {
    opacity: 1;
    transform: translateY(0);
}

.description {
    white-space: pre-wrap;
}

@media (max-width: 768px) {
    .section-title {
        font-size: 36px;
    }
    
    .section {
        min-height: auto;
        padding: 60px 20px;
    }
}
</style>